import styled from 'styled-components';

export const Container = styled.div`
  .header-nav-location-info {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }
`;
